// Hvězdičky a počet hodnocení nahoře na detailu vedou na hodnocení níž na stránce.
// Nativní odkaz „Podrobnosti hodnocení" přepne záložku a posune na ni, ale jen když
// záložka ještě není aktivní; hvězdičky a počet hodnocení nedělají nic.
const myRatingLinkTexts = {
    cs: { show: "Zobrazit hodnocení", write: "Napsat první hodnocení" },
    sk: { show: "Zobraziť hodnotenia", write: "Napísať prvé hodnotenie" },
};

function myRatingScrollTarget() {
    const $tab = $("#ratingTab");
    const $accordion = $(".shp-accordion-link[href='#ratingTab']");

    if ($accordion.length && $accordion.is(":visible")) {
        return $accordion;
    }

    return $tab.closest(".shp-tabs-wrapper").length ? $tab.closest(".shp-tabs-wrapper") : $tab;
}

$(document).ready(function () {
    if (getShoptetDataLayer("pageType") !== "productDetail") return;

    const $wrapper = $(".stars-wrapper").first();
    const $link = $wrapper.find(".stars-link");
    if (!$wrapper.length || !$link.length || !$("#ratingTab").length) return;

    const texts = myRatingLinkTexts[getShoptetDataLayer("language")] || myRatingLinkTexts.cs;
    const countMatch = $wrapper.find(".stars-label").text().match(/\d+/);
    const count = countMatch ? Number(countMatch[0]) : 0;

    $link.text(count ? texts.show + " (" + count + ")" : texts.write);
    $wrapper.addClass("myrating-link");

    // Klik kamkoli do řádku hodnocení = klik na nativní odkaz (přepne záložku a posune)
    $wrapper.on("click", ".stars, .stars-label", function () {
        $link.trigger("click");
    });

    // Záložka už je aktivní → Shoptet neposune, posuneme sami
    $link.on("click", function () {
        if ($("#ratingTab").hasClass("active")) {
            shoptet.scroll.scrollToEl(myRatingScrollTarget());
        }
    });
});
